import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Port from 'ferries/Home/components/FerrySearchMask/Port';
import DatePicker from 'ferries/Home/components/FerrySearchMask/DatePicker';
import PortModal from 'ferries/Home/components/FerrySearchMask/Mobile/PortModal';
import SearchButton from 'components/SearchMask/SearchButton';
import {isGreekText} from 'providers/ferries/autocompleteResultsBasedOnTypedLanguage/utils';

const tripIndex = 0;

const SingleTrip = ({
  isMobile, loading, isRoundTrip, triedToSubmit, trips,  queries, errors, setPort,
  fetchSuggestions, clearSuggestions, onSuggestionSelected, portString, swapPorts, setTypeTrip, setDate,
  setDates, setPortByThreeLetterCode, fillWithQuery, onChangePopularPortCountry, product, submitForm,
  translations
}) => {
  const {
    dep, arr, depSelected, arrSelected, depPopularPorts, arrPopularPorts, obDate, ibDate
  } = trips[tripIndex];
  const {dep: depTr, arr: arrTr, whereFrom, whereTo} = translations;

  const isGreekDeparture = isGreekText(dep);

  return (
    <form className="searchMask">
      <div className="grid no-gutter">
        <div className="destinationInput-wrapper">
          <div className="grid no-gutter">
            <div className="grid-item-sm mb-3">
              {
                isMobile ?
                  <PortModal
                    type='dep'
                    port={dep}
                    selected={depSelected}
                    placeholder={`${depTr}*`}
                    modalTitle={whereFrom}
                    tripIndex={tripIndex}
                    popularPorts={depPopularPorts}
                    queries={queries}
                    portString={portString}
                    onSuggestionSelected={onSuggestionSelected}
                    onChange={setPort}
                    fetchSuggestions={fetchSuggestions}
                    clearSuggestions={clearSuggestions}
                    setPortByThreeLetterCode={setPortByThreeLetterCode}
                    fillWithQuery={fillWithQuery}
                    onChangePopularPortCountry={onChangePopularPortCountry}
                    translations={translations}
                  /> : 
                  <Port
                    type='dep'
                    port={dep}
                    selected={depSelected}
                    className={{
                      input: 'mask-from form-control form-control-lg rounded-0 pr-6'
                    }}
                    placeholder={`${depTr}*`}
                    tripIndex={tripIndex}
                    popularPorts={depPopularPorts}
                    queries={queries}
                    portString={portString}
                    onSuggestionSelected={onSuggestionSelected}
                    onChange={setPort}
                    fetchSuggestions={fetchSuggestions}
                    clearSuggestions={clearSuggestions}
                    fillWithQuery={fillWithQuery}
                    setPortByThreeLetterCode={setPortByThreeLetterCode}
                    onChangePopularPortCountry={onChangePopularPortCountry}
                    translations={translations}
                  />
              }
              {
                triedToSubmit && errors?.[0]?.dep?.[0] &&
                <div className='searchMask-error'>{errors[0].dep[0]}</div>
              }
              <button
                aria-label="swap ports"
                className="swapAirports"
                type="button"
                onClick={() => swapPorts(tripIndex)}
              >
                <i className="icon icon-swap-horizontal" aria-hidden="true"/>
              </button>
            </div>
            <div className="grid-item-sm mb-3">
              {
                isMobile ?
                  <PortModal
                    type='arr'
                    port={arr}
                    isGreekDeparture={isGreekDeparture}
                    selected={arrSelected}
                    placeholder={`${arrTr}*`}
                    modalTitle={whereTo}
                    tripIndex={tripIndex}
                    popularPorts={arrPopularPorts}
                    queries={queries}
                    portString={portString}
                    onSuggestionSelected={onSuggestionSelected}
                    onChange={setPort}
                    fetchSuggestions={fetchSuggestions}
                    clearSuggestions={clearSuggestions}
                    setPortByThreeLetterCode={setPortByThreeLetterCode}
                    fillWithQuery={fillWithQuery}
                    onChangePopularPortCountry={onChangePopularPortCountry}
                    translations={translations}
                  /> :
                  <Port
                    type='arr'
                    port={arr}
                    isGreekDeparture={isGreekDeparture}
                    selected={arrSelected}
                    className={{
                      input: 'mask-to form-control form-control-lg rounded-0 pr-6'
                    }}
                    placeholder={`${arrTr}*`}
                    tripIndex={tripIndex}
                    popularPorts={arrPopularPorts}
                    portString={portString}
                    onSuggestionSelected={onSuggestionSelected}
                    onChange={setPort}
                    fetchSuggestions={fetchSuggestions}
                    clearSuggestions={clearSuggestions}
                    setPortByThreeLetterCode={setPortByThreeLetterCode}
                    onChangePopularPortCountry={onChangePopularPortCountry}
                    translations={translations}
                  />
              }
              {
                triedToSubmit && errors?.[0]?.arr?.[0] &&
                <div className='searchMask-error'>{errors[0].arr[0]}</div>
              }
            </div>
          </div>
        </div>
        <DatePicker
          isMobile={isMobile}
          showTripTypes
          cssClass="mask-date"
          tripIndex={tripIndex}
          roundTrip={isRoundTrip}
          obDate={obDate}
          ibDate={ibDate}
          setRoundTrip={setTypeTrip}
          setDates={setDates}
          setDate={setDate}
          translations={translations}
        />
        <SearchButton
          loading={loading}
          product={product}
          submitForm={submitForm}
          translations={translations}
        />
      </div>
    </form>
  );
};

SingleTrip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isRoundTrip: PropTypes.bool.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired,
  trips: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  queries: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  swapPorts:PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  fillWithQuery: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  onChangePopularPortCountry: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    dep: PropTypes.string.isRequired,
    arr: PropTypes.string.isRequired,
    whereFrom: PropTypes.string.isRequired,
    whereTo: PropTypes.string.isRequired
  })
};

export default observer(SingleTrip);
